import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=3af56f0f&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=3af56f0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af56f0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3af56f0f')) {
      api.createRecord('3af56f0f', component.options)
    } else {
      api.reload('3af56f0f', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=3af56f0f&scoped=true&", function () {
      api.rerender('3af56f0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2s02Cl9xpJo5s/JS/comp/DateRangeExt.vue"
export default component.exports